import React from "react";
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from "react-router-dom";

import { UserProvider } from "./contexts/UserContext";
import PrivateRoute from "./components/PrivateRoute";

import Login from "./components/Login";
import Banner from "./components/Banner";
import Menu from "./components/Menu";
import Home from "./components/Home";
import Dashboard from "./components/Dashboard";
import DataCollected from "./components/DataCollected";
import DataDetail from "./components/DataDetail";
import MyUser from "./components/MyUser";
import Footer from "./components/Footer";
import Table from "./components/Table";

function BannerLink() {
  const location = useLocation();
  const to = location.pathname === "/" ? "/" : "/home";
  return (
    <Link to={to} style={{ textDecoration: "none", color: "inherit" }}>
      <Banner />
    </Link>
  );
}

function PublicLayout({ children }) {
  return (
    <>
      <BannerLink />
      {children}
      <Footer />
    </>
  );
}

function PrivateLayout({ children }) {
  return (
    <>
      <BannerLink />
      <Menu />
      {children}
      <Footer />
    </>
  );
}

function DetailLayout({ children }) {
  return (
    <>
      <BannerLink />
      {children}
      <Footer />
    </>
  );
}

function App() {
  return (
    <UserProvider>
      <Router>
        <Routes>
          {/* Ruta pública */}
          <Route
            path="/"
            element={
              <PublicLayout>
                <Login />
              </PublicLayout>
            }
          />

          {/* Rutas privadas */}
          <Route
            path="/home"
            element={
              <PrivateRoute>
                <PrivateLayout>
                  <Home />
                </PrivateLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/tablero"
            element={
              <PrivateRoute>
                <PrivateLayout>
                  <Dashboard />
                </PrivateLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/datos"
            element={
              <PrivateRoute>
                <PrivateLayout>
                  <DataCollected />
                </PrivateLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/mi-usuario"
            element={
              <PrivateRoute>
                <PrivateLayout>
                  <MyUser />
                </PrivateLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/table"
            element={
              <PrivateRoute>
                <PrivateLayout>
                  <Table />
                </PrivateLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/util/obtener"
            element={
              <PrivateRoute>
                <PrivateLayout>
                  <Home />
                </PrivateLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/util/actualizar"
            element={
              <PrivateRoute>
                <PrivateLayout>
                  <Home />
                </PrivateLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/datos/:id"

            element={
              <PrivateRoute>
                <DetailLayout>
                  <DataDetail />
                </DetailLayout>
              </PrivateRoute>
            }
          />
          {/* <Route path="*" element={<div>Página no encontrada</div>} /> */}
        </Routes>
      </Router>
    </UserProvider>
  );
}

export default App;
